module.exports = __webpack_public_path__ + "media/images/weblink-5a5ad8839c34393ccd3ded5e4c92dd7b.png";